import * as React from 'react'

const NewJobsIcon = ({ stroke }) => (
  <svg
    width="22"
    height="21"
    viewBox="0 0 22 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 19.2V5.19995C7 4.26998 7 3.80499 7.10222 3.42349C7.37962 2.38822 8.18827 1.57958 9.22354 1.30217C9.60504 1.19995 10.07 1.19995 11 1.19995C11.93 1.19995 12.395 1.19995 12.7765 1.30217C13.8117 1.57958 14.6204 2.38822 14.8978 3.42349C15 3.80499 15 4.26998 15 5.19995V19.2M4.2 19.2H17.8C18.9201 19.2 19.4802 19.2 19.908 18.982C20.2843 18.7902 20.5903 18.4843 20.782 18.1079C21 17.6801 21 17.1201 21 16V8.39995C21 7.27985 21 6.71979 20.782 6.29197C20.5903 5.91565 20.2843 5.60968 19.908 5.41794C19.4802 5.19995 18.9201 5.19995 17.8 5.19995H4.2C3.07989 5.19995 2.51984 5.19995 2.09202 5.41794C1.71569 5.60968 1.40973 5.91565 1.21799 6.29197C1 6.71979 1 7.27985 1 8.39995V16C1 17.1201 1 17.6801 1.21799 18.1079C1.40973 18.4843 1.71569 18.7902 2.09202 18.982C2.51984 19.2 3.0799 19.2 4.2 19.2Z"
      stroke={stroke ? stroke : '#A4BCFD'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default NewJobsIcon
